module.exports = __webpack_public_path__ + "images/Widest Image.png";